import PanelForm from './../panel/Form'
import styles from './Form.module.css';
import React, {useState} from "react";
import {Accordion, AccordionTab} from "primereact/accordion";

function Form() {


    const [selectedIndex, setSelectedIndex] = useState(0);

    const FAQ = (props) => (
        <div>
            {props.items.map( (item, index) => (
                <div className={styles.item} onClick={() => index == selectedIndex ? setSelectedIndex(-1) : setSelectedIndex(index)}>
                    <table>
                        <tbody>
                        <tr >
                            <td style={{width: '100%'}}>{item.question}</td>
                            <td style={{color: '#62a615'}}>{selectedIndex == index ? '-' : '+'}</td>
                        </tr>
                        </tbody>
                    </table>
                    {selectedIndex == index && (
                        <div className={styles.itemContent}>
                            {item.answer}
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
  return (
      <div className="wrapper" style={{padding: '0 10px 0 10px'}}>
          <PanelForm style={{background: '#FFFFFF', padding: 25}}>
              <h1>Häufig gestellte Fragen</h1>
          </PanelForm>
          <br/>
          <FAQ items={[
              {
                  question: "Habe ich in meinem Bundesland überhaupt Anspruch auf Bildungsurlaub – und wie viele Tage?",
                  answer: (
                      <p className="m-0">
                          In Deutschland gibt es 16 Bundesländer. In 14 Bundesländern besteht ein gesetzlicher Anspruch auf Bildungsurlaub (oft auch Bildungszeit oder Bildungsfreistellung genannt).
                          <br/>In Bayern und Sachsen gibt es aktuell kein Bildungsurlaubsgesetz – dort kann Freistellung nur freiwillig durch den Arbeitgeber, Tarifvertrag oder eine Betriebsvereinbarung geregelt werden.
                          <br/>Entscheidend ist immer das Bundesland deines Arbeitsortes, nicht dein Wohnort.
                          <br/>Übersicht nach Bundesland (Richtwerte bei einer 5-Tage-Woche):
                          <ul>
                              <li>Baden-Württemberg: 5 Tage pro Jahr</li>
                              <li>Bayern: kein gesetzlicher Anspruch auf Bildungsurlaub</li>
                              <li>Berlin: 5 Tage pro Jahr, Möglichkeit der Bündelung zu 10 Tagen in 2 Jahren</li>
                              <li>Brandenburg: 10 Tage in 2 Jahren</li>
                              <li>Bremen: 10 Tage in 2 Jahren</li>
                              <li>Hamburg: 10 Tage in 2 Jahren</li>
                              <li>Hessen: 5 Tage pro Jahr, mit Möglichkeit der Bündelung auf 10 Tage in 2 Jahren</li>
                              <li>Mecklenburg-Vorpommern: 5 Tage pro Jahr</li>
                              <li>Niedersachsen: 5 Tage pro Jahr (mit Möglichkeit der gebündelten Inanspruchnahme)</li>
                              <li>Nordrhein-Westfalen: 5 Tage pro Jahr, oft auch als 10 Tage in 2 Jahren nutzbar</li>
                              <li>Rheinland-Pfalz: 10 Tage in 2 Jahren</li>
                              <li>Saarland: 6 Tage pro Jahr (davon gelten 2 Tage als Eigenanteil, 4 als klassische Freistellung)</li>
                              <li>Sachsen: kein gesetzlicher Anspruch auf Bildungsurlaub</li>
                              <li>Schleswig-Holstein: 5 Tage pro Jahr, mit Bündelungsmöglichkeit auf 10 Tage in 2 Jahren</li>
                              <li>Thüringen: 5 Tage pro Jahr</li>
                          </ul>
                          Dazu ein kurzer Hinweis unten drunter, den du auch so stehen lassen kannst:
                          <br/>Hinweis: Die genaue Berechnung (z. B. bei Teilzeit oder anderer Verteilung der Arbeitstage) und Sonderregeln stehen im jeweiligen Landesgesetz. Angaben ohne Gewähr, Stand 2025.
                      </p>
                  )
              },
              {
                  question: "Wie läuft Bildungsurlaub konkret ab?",
                  answer: (
                      <p className="m-0">
                          Der Ablauf ist in allen Bundesländern ähnlich, auch wenn Details unterschiedlich geregelt sind:
                          <ol>
                              <li>
                                  <b>Kurs auswählen</b>
                                  <div>
                                      Du suchst eine Veranstaltung, die als Bildungsurlaub/Bildungszeit geeignet oder anerkannt ist – passend zu deinem Bundesland.
                                  </div>
                              </li>
                              <li>
                                  <b>Unterlagen für den Antrag vorbereiten</b>
                                  <div>
                                      Üblich sind: Programm mit Inhalten, tägliche Unterrichtszeiten, Angaben zum Träger, ggf. Anerkennungsbescheid für dein Bundesland.
                                  </div>
                              </li>
                              <li>
                                  <b>Antrag beim Arbeitgeber stellen</b>
                                  <div>
                                      Du reichst den Antrag schriftlich und fristgerecht ein (je nach Bundesland meist 4–8 Wochen vor Beginn).
                                  </div>
                              </li>
                              <li>
                                  <b>Entscheidung abwarten</b>
                                  <div>
                                      Der Arbeitgeber prüft, ob die Voraussetzungen erfüllt sind und ob betriebliche Gründe entgegenstehen. Die Entscheidung erfolgt in der Regel schriftlich.
                                  </div>
                              </li>
                              <li>
                                  <b>Bei Genehmigung Kurs verbindlich buchen</b>
                                  <div>
                                      Du meldest dich endgültig an bzw. bestätigst die Buchung. Die Kursgebühr zahlst du in der Regel direkt an den Anbieter.
                                  </div>
                              </li>
                              <li>
                                  <b>Teilnahme & Nachweis</b>
                                  <div>
                                      Nach Abschluss erhältst du eine Teilnahmebescheinigung, die du dem Arbeitgeber vorlegen kannst.
                                  </div>
                              </li>
                          </ol>
                      </p>
                  )
              },
              {
                  question: "Zählt Bildungsurlaub als normaler Urlaub oder bekomme ich mein Gehalt zusätzlich weiter?",
                  answer: (
                      <p className="m-0">
                          Bildungsurlaub ist zusätzliche Freistellung für Weiterbildung, getrennt vom regulären Erholungsurlaub.
                          <ul>
                              <li>Dein Gehalt wird während des Bildungsurlaubs weitergezahlt.</li>
                              <li>Dein Erholungsurlaub wird grundsätzlich nicht gekürzt, sofern der Kurs die gesetzlichen Anforderungen erfüllt.</li>
                              <li>Die Kursgebühren und ggf. Reise-/Übernachtungskosten trägst du in der Regel selbst; manche Arbeitgeber beteiligen sich freiwillig.</li>
                          </ul>
                          Die genaue Ausgestaltung kann je nach Landesrecht und Tarifvertrag leicht abweichen.
                      </p>
                  )
              },
              {
                  question: "Kann mein Arbeitgeber meinen Bildungsurlaub ablehnen – und aus welchen Gründen?",
                  answer: (
                      <p className="m-0">
                          Ja, aber nur in einem begrenzten Rahmen. Typische zulässige Ablehnungsgründe sind:
                          <ul>
                              <li>dringende betriebliche Gründe, z. B.</li>
                              <ul>
                                  <li>akuter Personalmangel</li>
                                  <li>bereits viele andere Freistellungen/Urlaube im gleichen Zeitraum</li>
                              </ul>
                              <li>formale Gründe, z. B.</li>
                              <ul>
                                  <li>Antragsfrist nicht eingehalten</li>
                                  <li>unvollständige Unterlagen</li>
                              </ul>
                              <li>fehlende Anerkennung, z. B.</li>
                              <ul>
                                  <li>der Kurs erfüllt nicht die Anforderungen des Landesgesetzes</li>
                                  <li>keine oder falsche Anerkennung für das Bundesland des Arbeitsortes</li>
                              </ul>
                          </ul>
                          In vielen Landesgesetzen ist vorgesehen, dass eine Ablehnung schriftlich und begründet erfolgen muss. Die genaue Regelung findest du im jeweiligen Gesetz deines Bundeslandes.
                      </p>
                  )
              },
              {
                  question: "Kann ich Bildungsurlaub schon in der Probezeit nehmen?",
                  answer: (
                      <p className="m-0">
                          In allen Bundesländern mit Bildungsurlaub ist der Anspruch an eine Mindest-Betriebszugehörigkeit geknüpft. Üblich sind rund 6 Monate, im Saarland z. B. 12 Monate.
                          <br/>Das bedeutet in der Praxis:
                          <ul>
                              <li>In vielen Fällen besteht während der klassischen Probezeit (6 Monate) noch kein gesetzlicher Anspruch.</li>
                              <li>Wenn deine Probezeit länger ist als die gesetzliche Wartezeit, kann Bildungsurlaub theoretisch auch innerhalb der Probezeit möglich sein – sofern alle Voraussetzungen erfüllt sind.</li>
                          </ul>
                          Ob du konkret während deiner Probezeit Bildungsurlaub nehmen kannst, hängt vom Landesgesetz und ggf. von betrieblichen Regelungen ab.
                      </p>
                  )
              },
              {
                  question: "Was passiert, wenn ich während des Bildungsurlaubs krank werde?",
                  answer: (
                      <p className="m-0">
                          In vielen Landesgesetzen wird Krankheit im Bildungsurlaub ähnlich behandelt wie im Erholungsurlaub:
                          <br/>Tage, an denen du nachweislich arbeitsunfähig bist, werden in der Regel nicht auf den Bildungsurlaub angerechnet.
                          <br/>Wichtig ist:
                          <ul>
                              <li>Du musst deinen Arbeitgeber unverzüglich informieren.</li>
                              <li>Du brauchst in der Regel eine ärztliche Bescheinigung über die Arbeitsunfähigkeit.</li>
                              <li>Den Veranstalter solltest du ebenfalls sofort informieren (Storno-/Umbuchungsregeln beachten).</li>
                          </ul>
                          <br/>Ob und wie du den Bildungsurlaub später nachholen kannst, hängt vom jeweiligen Landesrecht und den Bedingungen des Anbieters ab.
                      </p>
                  )
              },
              {
                  question: "Was passiert, wenn ich meinen Bildungsurlaub in einem Jahr nicht nutze – verfällt der Anspruch?",
                  answer: (
                      <p className="m-0">
                          Das ist je nach Bundesland unterschiedlich geregelt:
                          <ul>
                              <li>In einigen Bundesländern gibt es Jahresansprüche, die am Jahresende verfallen, wenn sie nicht genutzt werden (z. B. Baden-Württemberg).</li>
                              <li>In anderen Ländern ist ein Zwei-Jahres-Zeitraum vorgesehen (z. B. Berlin, Brandenburg, Rheinland-Pfalz). Dort können Ansprüche oft im nächsten Zeitraum gebündelt werden (z. B. „10 Tage in 2 Jahren“).</li>
                              <li>Teilweise sind Übertragungen oder gebündelte Inanspruchnahme ausdrücklich erlaubt (z. B. Niedersachsen, Schleswig-Holstein).</li>
                          </ul>
                          Faustregel:
                          <ul>
                              <li>Steht im Gesetz „5 Tage pro Jahr“, verfallen ungenutzte Tage oft zum Jahresende.</li>
                              <li>Steht „10 Tage in 2 Jahren“ oder es wird eine Übertragung beschrieben, kannst du Tage meist in den nächsten Zeitraum mitnehmen – innerhalb der dort genannten Grenzen.</li>
                          </ul>
                          Verbindlich ist immer die Regelung deines Bundeslandes.
                      </p>
                  )
              },
              {
                  question: "Gilt Bildungsurlaub auch für Teilzeit und Minijob?",
                  answer: (
                      <p className="m-0">
                          Grundsätzlich richtet sich der Anspruch nach deinem Status als Beschäftigte:r, nicht danach, ob du Vollzeit oder Teilzeit arbeitest. In vielen Landesgesetzen sind ausdrücklich auch Teilzeitkräfte und teilweise sogar arbeitnehmerähnliche Personen eingeschlossen.
                          <br/>Typisch ist:
                          <ul>
                              <li>Bei Teilzeit wird der Anspruch anteilig zur regelmäßigen Wochenarbeitszeit berechnet (z. B. weniger Tage bei nur 3 Arbeitstagen pro Woche).</li>
                              <li>Bei Minijobs kann ein Anspruch bestehen, wenn du rechtlich als Arbeitnehmer:in giltst und die weiteren Voraussetzungen (Bundesland, Wartezeit, regelmäßige Arbeitszeit) erfüllt sind.</li>
                          </ul>
                          Wie genau gerechnet wird und ab welcher Stundenzahl ein Anspruch entsteht, steht im jeweiligen Landesgesetz und teilweise in ergänzenden Hinweisen der Länder.
                      </p>
                  )
              }
          ]}/>
      </div>
  );
}

export default Form;
